<app-payment-batch-table [currentTabname]="tabName"></app-payment-batch-table>
